module.exports = __webpack_public_path__ + "img/Tony_Sudigala.4ca14464.png";